'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
import { useQuery } from '@tanstack/react-query';
import { chunk } from 'es-toolkit';
import { useState } from 'react';
import { UnauthQueryOptions } from '@/api';
import { useCheckKakaobank } from '@/hooks/useCheckKakaobank';
import { useWebviewTypeEntry } from '@/hooks/useWebviewTypeEntry';
import { RecentOrderGiftList } from './RecentOrderGiftList';
const recentGiftProductsQueryOptions = UnauthQueryOptions['get:/wello/v2/allows/home-love/main/recent-gift-products'];
export type RecentOrderGiftItem = NonNullable<NonNullable<Awaited<ReturnType<NonNullable<ReturnType<typeof recentGiftProductsQueryOptions>['queryFn']>>>['context']>['contents']>[number];
interface RecentOrderGiftsSectionProps {
  className?: string;
}

/**
 * 클라이언트에서 실시간 로딩 섹션
 */
export const RecentOrderGiftsSection = t0 => {
  const $ = _c(29);
  const {
    className
  } = t0;
  const [currentIndex, setCurrentIndex] = useState(0);
  const isKakaobank = useCheckKakaobank();
  const {
    isEntryResolved
  } = useWebviewTypeEntry();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = recentGiftProductsQueryOptions();
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = isEntryResolved && !isKakaobank;
  let t3;
  if ($[1] !== t2) {
    t3 = {
      ...t1,
      enabled: t2,
      staleTime: 30000,
      gcTime: 300000,
      refetchOnWindowFocus: true,
      retry: 3,
      select: _temp
    };
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const {
    data: t4,
    isLoading: isGiftListLoading,
    isError: isGiftListError
  } = useQuery(t3);
  let chunkedList;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[3] !== className || $[4] !== currentIndex || $[5] !== isGiftListError || $[6] !== isGiftListLoading || $[7] !== t4) {
    t9 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const recentGiftProductList = t4 === undefined ? [] : t4;
      chunkedList = chunk(recentGiftProductList, CHUNK_SIZE);
      const isShowCarousel = recentGiftProductList.length > CHUNK_SIZE;
      const shouldHideSection = !isGiftListLoading && recentGiftProductList.length === 0 || isGiftListError;
      if (shouldHideSection) {
        t9 = null;
        break bb0;
      }
      if ($[14] !== className) {
        t8 = cn("flex flex-col items-center gap-16 px-40 content-container", "mobile-tablet:px-0", className);
        $[14] = className;
        $[15] = t8;
      } else {
        t8 = $[15];
      }
      if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = cn("relative w-full flex-center", "mobile-tablet:justify-start mobile-tablet:px-20");
        t6 = <h2 className={cn("font-700 text-Gray-900 typo-h4", "mobile-tablet:typo-body1")}>전국에서 실시간 주문중!</h2>;
        $[16] = t5;
        $[17] = t6;
      } else {
        t5 = $[16];
        t6 = $[17];
      }
      t7 = isShowCarousel ? <div className={cn("absolute bottom-0 right-12 flex translate-y-1/2 items-center gap-8 px-12 py-8", "mobile-tablet:bottom-1/2 mobile-tablet:right-20 mobile-tablet:translate-y-1/2 mobile-tablet:gap-4")}>{chunkedList.map((_, chunkIndex) => <div key={chunkIndex} className={cn("size-4 rounded-pill bg-Gray-400 transition-colors duration-300", {
          "bg-Gray-500 size-6 mobile-tablet:size-4": chunkIndex === currentIndex
        })} />)}</div> : null;
    }
    $[3] = className;
    $[4] = currentIndex;
    $[5] = isGiftListError;
    $[6] = isGiftListLoading;
    $[7] = t4;
    $[8] = chunkedList;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
    $[12] = t8;
    $[13] = t9;
  } else {
    chunkedList = $[8];
    t5 = $[9];
    t6 = $[10];
    t7 = $[11];
    t8 = $[12];
    t9 = $[13];
  }
  if (t9 !== Symbol.for("react.early_return_sentinel")) {
    return t9;
  }
  let t10;
  if ($[18] !== t5 || $[19] !== t6 || $[20] !== t7) {
    t10 = <header className={t5}>{t6}{t7}</header>;
    $[18] = t5;
    $[19] = t6;
    $[20] = t7;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== chunkedList || $[23] !== isGiftListLoading) {
    t11 = <RecentOrderGiftList isLoading={isGiftListLoading} listItems={chunkedList} onSlideChange={setCurrentIndex} />;
    $[22] = chunkedList;
    $[23] = isGiftListLoading;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== t10 || $[26] !== t11 || $[27] !== t8) {
    t12 = <section className={t8}>{t10}{t11}</section>;
    $[25] = t10;
    $[26] = t11;
    $[27] = t8;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  return t12;
};
const CHUNK_SIZE = 3;
function _temp(data) {
  return data.context?.contents ?? [];
}